import { StoryQuestion } from "chq";

const showUnsplashImageFinder = (organizationName?: string, selectedPrompt?: StoryQuestion | null) => !(organizationName === "Deloitte" || organizationName === "Santander" || organizationName === "Intellia Therapeutics" || organizationName === "Synopsys" || organizationName === "International Rescue Committee" || selectedPrompt?.allowedTypes === "just_videos");

export default showUnsplashImageFinder;
